import * as te from "react";
import Qr, { forwardRef as et, useContext as Wt, useRef as zt, useCallback as Ut, useEffect as rt, useMemo as cr, useState as Fr } from "react";
import { motion as qt, AnimatePresence as Lr } from "framer-motion";
import { css as qe } from "@emotion/react";
import { getColor as Z, zIndex as tt, applyBoxStyle as ur } from "@illa-design/theme";
import { v4 as nt } from "uuid";
import { LoadingIcon as Bt, WarningCircleIcon as Gt, SuccessCircleIcon as Jt, ErrorCircleIcon as Kt, InfoCircleIcon as Ht, CloseIcon as Zt } from "@illa-design/icon";
var fr = { exports: {} }, _e = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function Xt() {
  if (jr)
    return _e;
  jr = 1;
  var e = Qr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, p, h) {
    var d, m = {}, T = null, A = null;
    h !== void 0 && (T = "" + h), p.key !== void 0 && (T = "" + p.key), p.ref !== void 0 && (A = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (m[d] = p[d]);
    if (u && u.defaultProps)
      for (d in p = u.defaultProps, p)
        m[d] === void 0 && (m[d] = p[d]);
    return { $$typeof: r, type: u, key: T, ref: A, props: m, _owner: o.current };
  }
  return _e.Fragment = n, _e.jsx = l, _e.jsxs = l, _e;
}
var xe = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function Qt() {
  return Vr || (Vr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Qr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), S = Symbol.iterator, g = "@@iterator";
    function D(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = S && t[S] || t[g];
      return typeof s == "function" ? s : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, f = new Array(s > 1 ? s - 1 : 0), y = 1; y < s; y++)
          f[y - 1] = arguments[y];
        $("error", t, f);
      }
    }
    function $(t, s, f) {
      {
        var y = x.ReactDebugCurrentFrame, C = y.getStackAddendum();
        C !== "" && (s += "%s", f = f.concat([C]));
        var I = f.map(function(_) {
          return String(_);
        });
        I.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, I);
      }
    }
    var k = !1, c = !1, j = !1, N = !1, He = !1, Pe;
    Pe = Symbol.for("react.module.reference");
    function Ze(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || He || t === o || t === h || t === d || N || t === A || k || c || j || typeof t == "object" && t !== null && (t.$$typeof === T || t.$$typeof === m || t.$$typeof === l || t.$$typeof === u || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Pe || t.getModuleId !== void 0));
    }
    function Xe(t, s, f) {
      var y = t.displayName;
      if (y)
        return y;
      var C = s.displayName || s.name || "";
      return C !== "" ? f + "(" + C + ")" : f;
    }
    function Ne(t) {
      return t.displayName || "Context";
    }
    function K(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            var s = t;
            return Ne(s) + ".Consumer";
          case l:
            var f = t;
            return Ne(f._context) + ".Provider";
          case p:
            return Xe(t, t.render, "ForwardRef");
          case m:
            var y = t.displayName || null;
            return y !== null ? y : K(t.type) || "Memo";
          case T: {
            var C = t, I = C._payload, _ = C._init;
            try {
              return K(_(I));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ee = Object.assign, ne = 0, Ae, $e, ve, Ie, me, ke, Me;
    function De() {
    }
    De.__reactDisabledLog = !0;
    function Qe() {
      {
        if (ne === 0) {
          Ae = console.log, $e = console.info, ve = console.warn, Ie = console.error, me = console.group, ke = console.groupCollapsed, Me = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: De,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ne++;
      }
    }
    function er() {
      {
        if (ne--, ne === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ee({}, t, {
              value: Ae
            }),
            info: ee({}, t, {
              value: $e
            }),
            warn: ee({}, t, {
              value: ve
            }),
            error: ee({}, t, {
              value: Ie
            }),
            group: ee({}, t, {
              value: me
            }),
            groupCollapsed: ee({}, t, {
              value: ke
            }),
            groupEnd: ee({}, t, {
              value: Me
            })
          });
        }
        ne < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var he = x.ReactCurrentDispatcher, ye;
    function ie(t, s, f) {
      {
        if (ye === void 0)
          try {
            throw Error();
          } catch (C) {
            var y = C.stack.trim().match(/\n( *(at )?)/);
            ye = y && y[1] || "";
          }
        return `
` + ye + t;
      }
    }
    var ge = !1, se;
    {
      var rr = typeof WeakMap == "function" ? WeakMap : Map;
      se = new rr();
    }
    function v(t, s) {
      if (!t || ge)
        return "";
      {
        var f = se.get(t);
        if (f !== void 0)
          return f;
      }
      var y;
      ge = !0;
      var C = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var I;
      I = he.current, he.current = null, Qe();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (re) {
              y = re;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (re) {
              y = re;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            y = re;
          }
          t();
        }
      } catch (re) {
        if (re && y && typeof re.stack == "string") {
          for (var b = re.stack.split(`
`), W = y.stack.split(`
`), M = b.length - 1, F = W.length - 1; M >= 1 && F >= 0 && b[M] !== W[F]; )
            F--;
          for (; M >= 1 && F >= 0; M--, F--)
            if (b[M] !== W[F]) {
              if (M !== 1 || F !== 1)
                do
                  if (M--, F--, F < 0 || b[M] !== W[F]) {
                    var J = `
` + b[M].replace(" at new ", " at ");
                    return t.displayName && J.includes("<anonymous>") && (J = J.replace("<anonymous>", t.displayName)), typeof t == "function" && se.set(t, J), J;
                  }
                while (M >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        ge = !1, he.current = I, er(), Error.prepareStackTrace = C;
      }
      var fe = t ? t.displayName || t.name : "", Dr = fe ? ie(fe) : "";
      return typeof t == "function" && se.set(t, Dr), Dr;
    }
    function Ee(t, s, f) {
      return v(t, !1);
    }
    function ce(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function ae(t, s, f) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, ce(t));
      if (typeof t == "string")
        return ie(t);
      switch (t) {
        case h:
          return ie("Suspense");
        case d:
          return ie("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return Ee(t.render);
          case m:
            return ae(t.type, s, f);
          case T: {
            var y = t, C = y._payload, I = y._init;
            try {
              return ae(I(C), s, f);
            } catch {
            }
          }
        }
      return "";
    }
    var Fe = Object.prototype.hasOwnProperty, Cr = {}, wr = x.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var s = t._owner, f = ae(t.type, t._source, s ? s.type : null);
        wr.setExtraStackFrame(f);
      } else
        wr.setExtraStackFrame(null);
    }
    function xt(t, s, f, y, C) {
      {
        var I = Function.call.bind(Fe);
        for (var _ in t)
          if (I(t, _)) {
            var b = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((y || "React class") + ": " + f + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              b = t[_](s, _, y, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              b = M;
            }
            b && !(b instanceof Error) && (Le(C), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", f, _, typeof b), Le(null)), b instanceof Error && !(b.message in Cr) && (Cr[b.message] = !0, Le(C), E("Failed %s type: %s", f, b.message), Le(null));
          }
      }
    }
    var St = Array.isArray;
    function tr(t) {
      return St(t);
    }
    function Ct(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, f = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return f;
      }
    }
    function wt(t) {
      try {
        return Rr(t), !1;
      } catch {
        return !0;
      }
    }
    function Rr(t) {
      return "" + t;
    }
    function Tr(t) {
      if (wt(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ct(t)), Rr(t);
    }
    var be = x.ReactCurrentOwner, Rt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Or, Pr, nr;
    nr = {};
    function Tt(t) {
      if (Fe.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Ot(t) {
      if (Fe.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Pt(t, s) {
      if (typeof t.ref == "string" && be.current && s && be.current.stateNode !== s) {
        var f = K(be.current.type);
        nr[f] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K(be.current.type), t.ref), nr[f] = !0);
      }
    }
    function Nt(t, s) {
      {
        var f = function() {
          Or || (Or = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function At(t, s) {
      {
        var f = function() {
          Pr || (Pr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var $t = function(t, s, f, y, C, I, _) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: f,
        props: _,
        // Record the component responsible for creating this element.
        _owner: I
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: C
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function It(t, s, f, y, C) {
      {
        var I, _ = {}, b = null, W = null;
        f !== void 0 && (Tr(f), b = "" + f), Ot(s) && (Tr(s.key), b = "" + s.key), Tt(s) && (W = s.ref, Pt(s, C));
        for (I in s)
          Fe.call(s, I) && !Rt.hasOwnProperty(I) && (_[I] = s[I]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (I in M)
            _[I] === void 0 && (_[I] = M[I]);
        }
        if (b || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && Nt(_, F), W && At(_, F);
        }
        return $t(t, b, W, C, y, be.current, _);
      }
    }
    var ar = x.ReactCurrentOwner, Nr = x.ReactDebugCurrentFrame;
    function ue(t) {
      if (t) {
        var s = t._owner, f = ae(t.type, t._source, s ? s.type : null);
        Nr.setExtraStackFrame(f);
      } else
        Nr.setExtraStackFrame(null);
    }
    var or;
    or = !1;
    function ir(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Ar() {
      {
        if (ar.current) {
          var t = K(ar.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function kt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), f = t.lineNumber;
          return `

Check your code at ` + s + ":" + f + ".";
        }
        return "";
      }
    }
    var $r = {};
    function Mt(t) {
      {
        var s = Ar();
        if (!s) {
          var f = typeof t == "string" ? t : t.displayName || t.name;
          f && (s = `

Check the top-level render call using <` + f + ">.");
        }
        return s;
      }
    }
    function Ir(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var f = Mt(s);
        if ($r[f])
          return;
        $r[f] = !0;
        var y = "";
        t && t._owner && t._owner !== ar.current && (y = " It was passed a child from " + K(t._owner.type) + "."), ue(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, y), ue(null);
      }
    }
    function kr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (tr(t))
          for (var f = 0; f < t.length; f++) {
            var y = t[f];
            ir(y) && Ir(y, s);
          }
        else if (ir(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var C = D(t);
          if (typeof C == "function" && C !== t.entries)
            for (var I = C.call(t), _; !(_ = I.next()).done; )
              ir(_.value) && Ir(_.value, s);
        }
      }
    }
    function Dt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var f;
        if (typeof s == "function")
          f = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === m))
          f = s.propTypes;
        else
          return;
        if (f) {
          var y = K(s);
          xt(f, t.props, "prop", y, t);
        } else if (s.PropTypes !== void 0 && !or) {
          or = !0;
          var C = K(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", C || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ft(t) {
      {
        for (var s = Object.keys(t.props), f = 0; f < s.length; f++) {
          var y = s[f];
          if (y !== "children" && y !== "key") {
            ue(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), ue(null);
            break;
          }
        }
        t.ref !== null && (ue(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ue(null));
      }
    }
    function Mr(t, s, f, y, C, I) {
      {
        var _ = Ze(t);
        if (!_) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = kt(C);
          W ? b += W : b += Ar();
          var M;
          t === null ? M = "null" : tr(t) ? M = "array" : t !== void 0 && t.$$typeof === r ? (M = "<" + (K(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, b);
        }
        var F = It(t, s, f, C, I);
        if (F == null)
          return F;
        if (_) {
          var J = s.children;
          if (J !== void 0)
            if (y)
              if (tr(J)) {
                for (var fe = 0; fe < J.length; fe++)
                  kr(J[fe], t);
                Object.freeze && Object.freeze(J);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              kr(J, t);
        }
        return t === a ? Ft(F) : Dt(F), F;
      }
    }
    function Lt(t, s, f) {
      return Mr(t, s, f, !0);
    }
    function jt(t, s, f) {
      return Mr(t, s, f, !1);
    }
    var Vt = jt, Yt = Lt;
    xe.Fragment = a, xe.jsx = Vt, xe.jsxs = Yt;
  }()), xe;
}
process.env.NODE_ENV === "production" ? fr.exports = Xt() : fr.exports = Qt();
var Ce = fr.exports;
function en(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function rn(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var tn = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(rn(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var l = en(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch (u) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', u);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Y = "-ms-", ze = "-moz-", w = "-webkit-", gr = "comm", Er = "rule", br = "decl", nn = "@import", at = "@keyframes", an = "@layer", on = Math.abs, Be = String.fromCharCode, sn = Object.assign;
function cn(e, r) {
  return V(e, 0) ^ 45 ? (((r << 2 ^ V(e, 0)) << 2 ^ V(e, 1)) << 2 ^ V(e, 2)) << 2 ^ V(e, 3) : 0;
}
function ot(e) {
  return e.trim();
}
function un(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function R(e, r, n) {
  return e.replace(r, n);
}
function lr(e, r) {
  return e.indexOf(r);
}
function V(e, r) {
  return e.charCodeAt(r) | 0;
}
function we(e, r, n) {
  return e.slice(r, n);
}
function X(e) {
  return e.length;
}
function _r(e) {
  return e.length;
}
function je(e, r) {
  return r.push(e), e;
}
function fn(e, r) {
  return e.map(r).join("");
}
var Ge = 1, de = 1, it = 0, B = 0, L = 0, pe = "";
function Je(e, r, n, a, o, i, l) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Ge, column: de, length: l, return: "" };
}
function Se(e, r) {
  return sn(Je("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function ln() {
  return L;
}
function dn() {
  return L = B > 0 ? V(pe, --B) : 0, de--, L === 10 && (de = 1, Ge--), L;
}
function G() {
  return L = B < it ? V(pe, B++) : 0, de++, L === 10 && (de = 1, Ge++), L;
}
function Q() {
  return V(pe, B);
}
function Ve() {
  return B;
}
function Oe(e, r) {
  return we(pe, e, r);
}
function Re(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function st(e) {
  return Ge = de = 1, it = X(pe = e), B = 0, [];
}
function ct(e) {
  return pe = "", e;
}
function Ye(e) {
  return ot(Oe(B - 1, dr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function pn(e) {
  for (; (L = Q()) && L < 33; )
    G();
  return Re(e) > 2 || Re(L) > 3 ? "" : " ";
}
function vn(e, r) {
  for (; --r && G() && !(L < 48 || L > 102 || L > 57 && L < 65 || L > 70 && L < 97); )
    ;
  return Oe(e, Ve() + (r < 6 && Q() == 32 && G() == 32));
}
function dr(e) {
  for (; G(); )
    switch (L) {
      case e:
        return B;
      case 34:
      case 39:
        e !== 34 && e !== 39 && dr(L);
        break;
      case 40:
        e === 41 && dr(e);
        break;
      case 92:
        G();
        break;
    }
  return B;
}
function mn(e, r) {
  for (; G() && e + L !== 47 + 10; )
    if (e + L === 42 + 42 && Q() === 47)
      break;
  return "/*" + Oe(r, B - 1) + "*" + Be(e === 47 ? e : G());
}
function hn(e) {
  for (; !Re(Q()); )
    G();
  return Oe(e, B);
}
function yn(e) {
  return ct(We("", null, null, null, [""], e = st(e), 0, [0], e));
}
function We(e, r, n, a, o, i, l, u, p) {
  for (var h = 0, d = 0, m = l, T = 0, A = 0, S = 0, g = 1, D = 1, x = 1, E = 0, $ = "", k = o, c = i, j = a, N = $; D; )
    switch (S = E, E = G()) {
      case 40:
        if (S != 108 && V(N, m - 1) == 58) {
          lr(N += R(Ye(E), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        N += Ye(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        N += pn(S);
        break;
      case 92:
        N += vn(Ve() - 1, 7);
        continue;
      case 47:
        switch (Q()) {
          case 42:
          case 47:
            je(gn(mn(G(), Ve()), r, n), p);
            break;
          default:
            N += "/";
        }
        break;
      case 123 * g:
        u[h++] = X(N) * x;
      case 125 * g:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            D = 0;
          case 59 + d:
            x == -1 && (N = R(N, /\f/g, "")), A > 0 && X(N) - m && je(A > 32 ? Wr(N + ";", a, n, m - 1) : Wr(R(N, " ", "") + ";", a, n, m - 2), p);
            break;
          case 59:
            N += ";";
          default:
            if (je(j = Yr(N, r, n, h, d, o, u, $, k = [], c = [], m), i), E === 123)
              if (d === 0)
                We(N, r, j, j, k, i, m, u, c);
              else
                switch (T === 99 && V(N, 3) === 110 ? 100 : T) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    We(e, j, j, a && je(Yr(e, j, j, 0, 0, o, u, $, o, k = [], m), c), o, c, m, u, a ? k : c);
                    break;
                  default:
                    We(N, j, j, j, [""], c, 0, u, c);
                }
        }
        h = d = A = 0, g = x = 1, $ = N = "", m = l;
        break;
      case 58:
        m = 1 + X(N), A = S;
      default:
        if (g < 1) {
          if (E == 123)
            --g;
          else if (E == 125 && g++ == 0 && dn() == 125)
            continue;
        }
        switch (N += Be(E), E * g) {
          case 38:
            x = d > 0 ? 1 : (N += "\f", -1);
            break;
          case 44:
            u[h++] = (X(N) - 1) * x, x = 1;
            break;
          case 64:
            Q() === 45 && (N += Ye(G())), T = Q(), d = m = X($ = N += hn(Ve())), E++;
            break;
          case 45:
            S === 45 && X(N) == 2 && (g = 0);
        }
    }
  return i;
}
function Yr(e, r, n, a, o, i, l, u, p, h, d) {
  for (var m = o - 1, T = o === 0 ? i : [""], A = _r(T), S = 0, g = 0, D = 0; S < a; ++S)
    for (var x = 0, E = we(e, m + 1, m = on(g = l[S])), $ = e; x < A; ++x)
      ($ = ot(g > 0 ? T[x] + " " + E : R(E, /&\f/g, T[x]))) && (p[D++] = $);
  return Je(e, r, n, o === 0 ? Er : u, p, h, d);
}
function gn(e, r, n) {
  return Je(e, r, n, gr, Be(ln()), we(e, 2, -2), 0);
}
function Wr(e, r, n, a) {
  return Je(e, r, n, br, we(e, 0, a), we(e, a + 1, -1), a);
}
function le(e, r) {
  for (var n = "", a = _r(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function En(e, r, n, a) {
  switch (e.type) {
    case an:
      if (e.children.length)
        break;
    case nn:
    case br:
      return e.return = e.return || e.value;
    case gr:
      return "";
    case at:
      return e.return = e.value + "{" + le(e.children, a) + "}";
    case Er:
      e.value = e.props.join(",");
  }
  return X(n = le(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function bn(e) {
  var r = _r(e);
  return function(n, a, o, i) {
    for (var l = "", u = 0; u < r; u++)
      l += e[u](n, a, o, i) || "";
    return l;
  };
}
function _n(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function xn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var Sn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = Q(), o === 38 && i === 12 && (n[a] = 1), !Re(i); )
    G();
  return Oe(r, B);
}, Cn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (Re(o)) {
      case 0:
        o === 38 && Q() === 12 && (n[a] = 1), r[a] += Sn(B - 1, n, a);
        break;
      case 2:
        r[a] += Ye(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = Q() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Be(o);
    }
  while (o = G());
  return r;
}, wn = function(r, n) {
  return ct(Cn(st(r), n));
}, zr = /* @__PURE__ */ new WeakMap(), Rn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !zr.get(a)) && !o) {
      zr.set(r, !0);
      for (var i = [], l = wn(n, i), u = a.props, p = 0, h = 0; p < l.length; p++)
        for (var d = 0; d < u.length; d++, h++)
          r.props[h] = i[p] ? l[p].replace(/&\f/g, u[d]) : u[d] + " " + l[p];
    }
  }
}, Tn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, On = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Pn = function(r) {
  return r.type === "comm" && r.children.indexOf(On) > -1;
}, Nn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var l = !!n.parent, u = l ? n.parent.children : (
          // global rule at the root level
          o
        ), p = u.length - 1; p >= 0; p--) {
          var h = u[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (Pn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, ut = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, An = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!ut(n[a]))
      return !0;
  return !1;
}, Ur = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, $n = function(r, n, a) {
  ut(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Ur(r)) : An(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Ur(r)));
};
function ft(e, r) {
  switch (cn(e, r)) {
    case 5103:
      return w + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return w + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return w + e + ze + e + Y + e + e;
    case 6828:
    case 4268:
      return w + e + Y + e + e;
    case 6165:
      return w + e + Y + "flex-" + e + e;
    case 5187:
      return w + e + R(e, /(\w+).+(:[^]+)/, w + "box-$1$2" + Y + "flex-$1$2") + e;
    case 5443:
      return w + e + Y + "flex-item-" + R(e, /flex-|-self/, "") + e;
    case 4675:
      return w + e + Y + "flex-line-pack" + R(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return w + e + Y + R(e, "shrink", "negative") + e;
    case 5292:
      return w + e + Y + R(e, "basis", "preferred-size") + e;
    case 6060:
      return w + "box-" + R(e, "-grow", "") + w + e + Y + R(e, "grow", "positive") + e;
    case 4554:
      return w + R(e, /([^-])(transform)/g, "$1" + w + "$2") + e;
    case 6187:
      return R(R(R(e, /(zoom-|grab)/, w + "$1"), /(image-set)/, w + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return R(e, /(image-set\([^]*)/, w + "$1$`$1");
    case 4968:
      return R(R(e, /(.+:)(flex-)?(.*)/, w + "box-pack:$3" + Y + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + w + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return R(e, /(.+)-inline(.+)/, w + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (X(e) - 1 - r > 6)
        switch (V(e, r + 1)) {
          case 109:
            if (V(e, r + 4) !== 45)
              break;
          case 102:
            return R(e, /(.+:)(.+)-([^]+)/, "$1" + w + "$2-$3$1" + ze + (V(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~lr(e, "stretch") ? ft(R(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (V(e, r + 1) !== 115)
        break;
    case 6444:
      switch (V(e, X(e) - 3 - (~lr(e, "!important") && 10))) {
        case 107:
          return R(e, ":", ":" + w) + e;
        case 101:
          return R(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + w + (V(e, 14) === 45 ? "inline-" : "") + "box$3$1" + w + "$2$3$1" + Y + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (V(e, r + 11)) {
        case 114:
          return w + e + Y + R(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return w + e + Y + R(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return w + e + Y + R(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return w + e + Y + e + e;
  }
  return e;
}
var In = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case br:
        r.return = ft(r.value, r.length);
        break;
      case at:
        return le([Se(r, {
          value: R(r.value, "@", "@" + w)
        })], o);
      case Er:
        if (r.length)
          return fn(r.props, function(i) {
            switch (un(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return le([Se(r, {
                  props: [R(i, /:(read-\w+)/, ":" + ze + "$1")]
                })], o);
              case "::placeholder":
                return le([Se(r, {
                  props: [R(i, /:(plac\w+)/, ":" + w + "input-$1")]
                }), Se(r, {
                  props: [R(i, /:(plac\w+)/, ":" + ze + "$1")]
                }), Se(r, {
                  props: [R(i, /:(plac\w+)/, Y + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, kn = [In], Mn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var D = g.getAttribute("data-emotion");
      D.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || kn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, l, u = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var D = g.getAttribute("data-emotion").split(" "), x = 1; x < D.length; x++)
        i[D[x]] = !0;
      u.push(g);
    }
  );
  var p, h = [Rn, Tn];
  process.env.NODE_ENV !== "production" && h.push(Nn({
    get compat() {
      return S.compat;
    }
  }), $n);
  {
    var d, m = [En, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? d.insert(g.return) : g.value && g.type !== gr && d.insert(g.value + "{}"));
    } : _n(function(g) {
      d.insert(g);
    })], T = bn(h.concat(o, m)), A = function(D) {
      return le(yn(D), T);
    };
    p = function(D, x, E, $) {
      d = E, process.env.NODE_ENV !== "production" && x.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + x.map);
        }
      }), A(D ? D + "{" + x.styles + "}" : x.styles), $ && (S.inserted[x.name] = !0);
    };
  }
  var S = {
    key: n,
    sheet: new tn({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return S.sheet.hydrate(u), S;
}, pr = { exports: {} }, O = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qr;
function Dn() {
  if (qr)
    return O;
  qr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, T = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function $(c) {
    if (typeof c == "object" && c !== null) {
      var j = c.$$typeof;
      switch (j) {
        case r:
          switch (c = c.type, c) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case m:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case u:
                case d:
                case S:
                case A:
                case l:
                  return c;
                default:
                  return j;
              }
          }
        case n:
          return j;
      }
    }
  }
  function k(c) {
    return $(c) === h;
  }
  return O.AsyncMode = p, O.ConcurrentMode = h, O.ContextConsumer = u, O.ContextProvider = l, O.Element = r, O.ForwardRef = d, O.Fragment = a, O.Lazy = S, O.Memo = A, O.Portal = n, O.Profiler = i, O.StrictMode = o, O.Suspense = m, O.isAsyncMode = function(c) {
    return k(c) || $(c) === p;
  }, O.isConcurrentMode = k, O.isContextConsumer = function(c) {
    return $(c) === u;
  }, O.isContextProvider = function(c) {
    return $(c) === l;
  }, O.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, O.isForwardRef = function(c) {
    return $(c) === d;
  }, O.isFragment = function(c) {
    return $(c) === a;
  }, O.isLazy = function(c) {
    return $(c) === S;
  }, O.isMemo = function(c) {
    return $(c) === A;
  }, O.isPortal = function(c) {
    return $(c) === n;
  }, O.isProfiler = function(c) {
    return $(c) === i;
  }, O.isStrictMode = function(c) {
    return $(c) === o;
  }, O.isSuspense = function(c) {
    return $(c) === m;
  }, O.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === m || c === T || typeof c == "object" && c !== null && (c.$$typeof === S || c.$$typeof === A || c.$$typeof === l || c.$$typeof === u || c.$$typeof === d || c.$$typeof === D || c.$$typeof === x || c.$$typeof === E || c.$$typeof === g);
  }, O.typeOf = $, O;
}
var P = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Br;
function Fn() {
  return Br || (Br = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, T = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function $(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === m || v === T || typeof v == "object" && v !== null && (v.$$typeof === S || v.$$typeof === A || v.$$typeof === l || v.$$typeof === u || v.$$typeof === d || v.$$typeof === D || v.$$typeof === x || v.$$typeof === E || v.$$typeof === g);
    }
    function k(v) {
      if (typeof v == "object" && v !== null) {
        var Ee = v.$$typeof;
        switch (Ee) {
          case r:
            var ce = v.type;
            switch (ce) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case m:
                return ce;
              default:
                var ae = ce && ce.$$typeof;
                switch (ae) {
                  case u:
                  case d:
                  case S:
                  case A:
                  case l:
                    return ae;
                  default:
                    return Ee;
                }
            }
          case n:
            return Ee;
        }
      }
    }
    var c = p, j = h, N = u, He = l, Pe = r, Ze = d, Xe = a, Ne = S, K = A, ee = n, ne = i, Ae = o, $e = m, ve = !1;
    function Ie(v) {
      return ve || (ve = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), me(v) || k(v) === p;
    }
    function me(v) {
      return k(v) === h;
    }
    function ke(v) {
      return k(v) === u;
    }
    function Me(v) {
      return k(v) === l;
    }
    function De(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Qe(v) {
      return k(v) === d;
    }
    function er(v) {
      return k(v) === a;
    }
    function he(v) {
      return k(v) === S;
    }
    function ye(v) {
      return k(v) === A;
    }
    function ie(v) {
      return k(v) === n;
    }
    function ge(v) {
      return k(v) === i;
    }
    function se(v) {
      return k(v) === o;
    }
    function rr(v) {
      return k(v) === m;
    }
    P.AsyncMode = c, P.ConcurrentMode = j, P.ContextConsumer = N, P.ContextProvider = He, P.Element = Pe, P.ForwardRef = Ze, P.Fragment = Xe, P.Lazy = Ne, P.Memo = K, P.Portal = ee, P.Profiler = ne, P.StrictMode = Ae, P.Suspense = $e, P.isAsyncMode = Ie, P.isConcurrentMode = me, P.isContextConsumer = ke, P.isContextProvider = Me, P.isElement = De, P.isForwardRef = Qe, P.isFragment = er, P.isLazy = he, P.isMemo = ye, P.isPortal = ie, P.isProfiler = ge, P.isStrictMode = se, P.isSuspense = rr, P.isValidElementType = $, P.typeOf = k;
  }()), P;
}
process.env.NODE_ENV === "production" ? pr.exports = Dn() : pr.exports = Fn();
var Ln = pr.exports, lt = Ln, jn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Vn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, dt = {};
dt[lt.ForwardRef] = jn;
dt[lt.Memo] = Vn;
var Yn = !0;
function Wn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var pt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Yn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, zn = function(r, n, a) {
  pt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Un(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var qn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Gr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Bn = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", Gn = /[A-Z]|^ms/g, vt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, xr = function(r) {
  return r.charCodeAt(1) === 45;
}, Jr = function(r) {
  return r != null && typeof r != "boolean";
}, sr = /* @__PURE__ */ xn(function(e) {
  return xr(e) ? e : e.replace(Gn, "-$&").toLowerCase();
}), Ue = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(vt, function(a, o, i) {
          return H = {
            name: o,
            styles: i,
            next: H
          }, o;
        });
  }
  return qn[r] !== 1 && !xr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Jn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Kn = ["normal", "none", "initial", "inherit", "unset"], Hn = Ue, Zn = /^-ms-/, Xn = /-(.)/g, Kr = {};
  Ue = function(r, n) {
    if (r === "content" && (typeof n != "string" || Kn.indexOf(n) === -1 && !Jn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Hn(r, n);
    return a !== "" && !xr(r) && r.indexOf("-") !== -1 && Kr[r] === void 0 && (Kr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Zn, "ms-").replace(Xn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var mt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Te(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(mt);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return H = {
          name: n.name,
          styles: n.styles,
          next: H
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            H = {
              name: a.name,
              styles: a.styles,
              next: H
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Qn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = H, l = n(e);
        return H = i, Te(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var u = [], p = n.replace(vt, function(d, m, T) {
          var A = "animation" + u.length;
          return u.push("const " + A + " = keyframes`" + T.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + A + "}";
        });
        u.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(u, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function Qn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Te(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? a += i + "{" + r[l] + "}" : Jr(l) && (a += sr(i) + ":" + Ue(i, l) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(mt);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var u = 0; u < l.length; u++)
            Jr(l[u]) && (a += sr(i) + ":" + Ue(i, l[u]) + ";");
        else {
          var p = Te(e, r, l);
          switch (i) {
            case "animation":
            case "animationName": {
              a += sr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(Bn), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Hr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ht;
process.env.NODE_ENV !== "production" && (ht = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var H, Zr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  H = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (o = !1, i += Te(a, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(Gr), i += l[0]);
  for (var u = 1; u < r.length; u++)
    i += Te(a, n, r[u]), o && (process.env.NODE_ENV !== "production" && l[u] === void 0 && console.error(Gr), i += l[u]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(ht, function(T) {
    return p = T, "";
  })), Hr.lastIndex = 0;
  for (var h = "", d; (d = Hr.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var m = Un(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: m,
    styles: i,
    map: p,
    next: H,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: m,
    styles: i,
    next: H
  };
}, ea = function(r) {
  return r();
}, ra = te["useInsertionEffect"] ? te["useInsertionEffect"] : !1, ta = ra || ea, Ke = {}.hasOwnProperty, Sr = /* @__PURE__ */ te.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Mn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Sr.displayName = "EmotionCacheContext");
Sr.Provider;
var na = function(r) {
  return /* @__PURE__ */ et(function(n, a) {
    var o = Wt(Sr);
    return r(n, o, a);
  });
}, yt = /* @__PURE__ */ te.createContext({});
process.env.NODE_ENV !== "production" && (yt.displayName = "EmotionThemeContext");
var Xr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, aa = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Xr(n[1]);
}, oa = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), ia = function(r) {
  return r.replace(/\$/g, "-");
}, sa = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = aa(n[a]);
      if (o) {
        if (oa.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return ia(o);
      }
    }
}, vr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", mr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", gt = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ke.call(n, o) && (a[o] = n[o]);
  if (a[vr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = sa(new Error().stack);
    i && (a[mr] = i);
  }
  return a;
}, ca = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return pt(n, a, o), ta(function() {
    return zn(n, a, o);
  }), null;
}, Et = /* @__PURE__ */ na(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[vr], i = [a], l = "";
  typeof e.className == "string" ? l = Wn(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var u = Zr(i, void 0, te.useContext(yt));
  if (process.env.NODE_ENV !== "production" && u.name.indexOf("-") === -1) {
    var p = e[mr];
    p && (u = Zr([u, "label:" + p + ";"]));
  }
  l += r.key + "-" + u.name;
  var h = {};
  for (var d in e)
    Ke.call(e, d) && d !== "css" && d !== vr && (process.env.NODE_ENV === "production" || d !== mr) && (h[d] = e[d]);
  return h.ref = n, h.className = l, /* @__PURE__ */ te.createElement(te.Fragment, null, /* @__PURE__ */ te.createElement(ca, {
    cache: r,
    serialized: u,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ te.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (Et.displayName = "EmotionCssPropInternal");
var bt = Et, hr = Ce.Fragment;
function U(e, r, n) {
  return Ke.call(r, "css") ? Ce.jsx(bt, gt(e, r), n) : Ce.jsx(e, r, n);
}
function _t(e, r, n) {
  return Ke.call(r, "css") ? Ce.jsxs(bt, gt(e, r), n) : Ce.jsxs(e, r, n);
}
const ua = qe`
  pointer-events: visible;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: 9px 16px;
  border-radius: 4px;
  box-shadow: 0 4px 10px 0 ${Z("blackAlpha", "07")};
  border: solid 1px ${Z("gray", "08")};
  background-color: ${Z("white", "01")};
  margin-bottom: 16px;
`;
function fa(e) {
  return qe`
    font-size: 14px;
    margin-left: ${e ? "8px" : "0"};
    color: ${Z("gray", "02")};
  `;
}
const la = qe`
  display: inline-flex;
  pointer-events: none;
  z-index: ${tt.message};
  position: fixed;
  left: 0;
  right: 0;
  top: 16px;
  align-items: center;
  flex-direction: column;
`, da = qe`
  display: inline-flex;
  pointer-events: none;
  z-index: ${tt.message};
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  flex-direction: column;
`, z = {
  maxCount: 5,
  duration: 3e3,
  listener: [],
  messageList: []
};
function pa() {
  return {
    getMessage: () => z.messageList,
    setMessage: (e) => {
      z.messageList = e, z.listener.forEach((r) => {
        r.onStoreChange();
      });
    },
    subscribe: (e) => {
      const r = {
        listenerId: nt(),
        onStoreChange: e
      };
      return z.listener.push(r), r.onStoreChange(), r;
    },
    unSubscribe: (e) => {
      z.listener.splice(z.listener.findIndex((r) => r.listenerId === e), 1);
    },
    add: (e) => {
      z.messageList.push(e), z.listener.forEach((r) => {
        r.onStoreChange();
      });
    },
    updateConfig: (e) => {
      e.duration != null && (z.duration = e.duration), e.maxCount != null && (z.maxCount = e.maxCount);
    },
    getConfig: () => ({
      maxCount: z.maxCount,
      duration: z.duration
    }),
    remove: (e) => {
      const r = z.messageList.findIndex((n) => n.id === e);
      r != -1 && (z.messageList.splice(r, 1), z.listener.forEach((n) => {
        n.onStoreChange();
      }));
    }
  };
}
const q = pa(), yr = et((e, r) => {
  const { type: n, closable: a, showIcon: o = !0, duration: i, id: l = "", position: u, icon: p, content: h, onClose: d } = e, m = zt(), T = Ut(() => {
    var g;
    let S;
    i ? S = window.setTimeout(() => {
      q.remove(l), d == null || d();
    }, i) : S = window.setTimeout(() => {
      q.remove(l), d == null || d(), m.current = void 0;
    }, ((g = q.getConfig()) == null ? void 0 : g.duration) ?? 3e3), m.current = S;
  }, [i, l, d]);
  rt(() => (T(), () => {
    m.current && (clearTimeout(m.current), m.current = void 0);
  }), [T]);
  const A = cr(() => {
    if (o) {
      if (p)
        return p;
      switch (n) {
        case "info":
          return U(Ht, { fs: "16px", c: Z("blue", "03") });
        case "error":
          return U(Kt, { fs: "16px", c: Z("red", "03") });
        case "success":
          return U(Jt, { fs: "16px", c: Z("green", "03") });
        case "warning":
          return U(Gt, { fs: "16px", c: Z("red", "03") });
        case "loading":
          return U(Bt, { spin: !0, fs: "16px", c: Z("blue", "03") });
        case "normal":
        default:
          return U(hr, {});
      }
    } else
      return U(hr, {});
  }, [o, p, n]);
  return _t(qt.div, { ref: r, layout: !0, exit: {
    opacity: 0,
    transition: {
      opacity: { duration: 0.2, ease: "linear" }
    }
  }, animate: {
    opacity: 1
  }, initial: {
    opacity: 0
  }, transition: { duration: 0.2 }, css: [ua, ur(e)], onMouseEnter: () => {
    m.current && (clearTimeout(m.current), m.current = void 0);
  }, onMouseLeave: () => {
    T();
  }, children: [A, U("span", { css: fa(o && n !== "normal"), children: h }), a && U(Zt, { fs: "8px", ml: "15px", c: Z("gray", "03"), onClick: () => {
    q.remove(l), d == null || d();
  } })] });
});
yr.displayName = "Message";
const va = (e) => {
  const [r, n] = Fr([]), [a, o] = Fr([]);
  rt(() => {
    const u = q.subscribe(() => {
      n(q.getMessage().filter((p) => p.position === "top")), o(q.getMessage().filter((p) => p.position === "bottom"));
    });
    return () => {
      q.unSubscribe(u.listenerId);
    };
  }, []);
  const i = cr(() => r.map((u) => U(yr, { ...u }, u.id)), [r]), l = cr(() => a.map((u) => U(yr, { ...u }, u.id)), [a]);
  return _t(hr, { children: [U("div", { css: [la, ur(e)], children: U(Lr, { children: i }) }), U("div", { css: [da, ur(e)], children: U(Lr, { children: l }) })] });
};
va.displayName = "MessageGroup";
const oe = (e) => (q.getMessage().length > (q.getConfig().maxCount ?? 5) && q.getMessage().shift(), e.id || (e.id = nt()), e.position || (e.position = "top"), e.type || (e.type = "normal"), q.add(e), e.id), ma = {
  info: (e) => (e.type = "info", oe(e)),
  error: (e) => (e.type = "error", oe(e)),
  success: (e) => (e.type = "success", oe(e)),
  loading: (e) => (e.type = "loading", oe(e)),
  warning: (e) => (e.type = "warning", oe(e)),
  normal: (e) => (e.type = "normal", oe(e)),
  show: oe,
  remove: (e) => {
    q.remove(e);
  },
  clear: () => {
    q.setMessage([]);
  },
  config: (e) => {
    q.updateConfig(e);
  }
};
function ha() {
  return ma;
}
const Sa = ha;
export {
  yr as Message,
  va as MessageGroup,
  Sa as createMessage,
  q as messageStore,
  ha as useMessage
};
//# sourceMappingURL=index.js.map
